import { render, staticRenderFns } from "./ReviewRating.vue?vue&type=template&id=0008515a&"
import script from "./ReviewRating.vue?vue&type=script&lang=js&"
export * from "./ReviewRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports